

import { LoaderPanel } from 'mga-commons'
import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import PanelRead from '../../components/commons/PanelRead'
import { selectUserProfile } from '../../slices/anonymous/anonymousAuthSlice'
import { anonymousFicheGetItem, selectFicheItem, selectIsLoading } from '../../slices/anonymous/anonymousFicheSlice'
import { FicheToMeta } from '../../utils/JsonLdUtils'
import { useMobileQuery } from '../../utils/MediaQueries'
import { FicheFullToString, FicheToKeywords, FicheToString } from '../../utils/StringUtils'
import PageFicheConsultationDesktop from '../PageFicheConsultationDesktop/index'
import PageFicheConsultationMobile from '../PageFicheConsultationMobile/index'
import './PageFicheConsultation.css'

const PageFicheConsultation = () => {

    const isMobile = useMobileQuery()

    const { i: idFiche } = useParams()
    const dispatch = useDispatch()

    const item = useSelector(selectFicheItem)
    const isLoading = useSelector(selectIsLoading)
    const userProfile = useSelector(selectUserProfile)

    useEffect(() => {

        // Load data
        dispatch(anonymousFicheGetItem({
            params: {
                idFiche
            }
        }))

    }, [])

    const renderDevice = () => {

        if (isMobile) {
            return <PageFicheConsultationMobile item={item} userProfile={userProfile} />
        }
        return <PageFicheConsultationDesktop item={item} userProfile={userProfile} />
    }


    if (isLoading) {
        return <LoaderPanel margin="60px" />
    }

    if (!item) {
        return <div className="none-fiche">Aucune fiche trouvée</div>
    }

    let schema = FicheToMeta(item)

    let txtMed = FicheToString(item)
    let txtMedFull = FicheFullToString(item) + ' sur Algérie-Docto.com'
    let txtKeywords = FicheToKeywords(item)

    return (
        <div className="page-fiche-consultation">
            <Helmet script={schema}>
                <title>{txtMed}</title>
                <meta name="description" content={txtMedFull} />
                <meta name="keywords" content={txtKeywords} />
                <link rel="canonical" href={window.location.origin + '/' + item.UrlRelatif} />
            </Helmet>
            <PanelRead>
                {renderDevice()}
            </PanelRead>
        </div>
    )
}

export default PageFicheConsultation
